module.exports = __webpack_public_path__ + "static/media/tie-rods.93f8f46a.svg";